import { ValidHeimspielStartingLineupProps } from './types'

const isValidHeimspielStartingLineupProps = (
  props: any,
): props is ValidHeimspielStartingLineupProps => !!props?.matchId

export { isValidHeimspielStartingLineupProps }
